import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserFacade } from 'src/app/modules/user/store';

@Injectable({
  providedIn: 'root',
})
export class AuthorizedGuard implements CanActivate {
  constructor(
    private router: Router,
    private readonly userFacade: UserFacade
  ) {}

  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<true | UrlTree> {
    return this.userFacade.isAuthorized$.pipe(
      map((_) => (_ ? true : this.router.createUrlTree([''])))
    );
  }
}
